module.exports = __webpack_public_path__ + "static/media/alejandro.ac36e46e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/alejandro.png
// module id = 1154
// module chunks = 0